module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Galatians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Galatians 1:1–2:21")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:1–5")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:6–10")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:11–24")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:1–10")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:11–14")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:15–21")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Galatians 3:1–5:12")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:1–5")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:6–18")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:19–25")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:26–29")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:1–11")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:12–20")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:21–5:1")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:2–12")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Galatians 5:13–6:18")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:13–15")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:16–26")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:1–10")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:11–18")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philippians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch2-s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Letter to the Philippians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch2-s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greetings (1:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction (1:3–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Narration on Paul’s Present Circumstances (1:12–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Purpose in Writing (1:27–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amplification on How the Readers Should Live (2:1–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commendation of Timothy and Epaphroditus (2:19–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Identity and Imitation (3:1–4:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practical Unity (4:2–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recapitulation of the Letter’s Main Themes (4:4–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friendship and the Giving and Receiving of Gifts (4:10–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter Closing (4:21–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "back"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/back#back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get the Complete Commentary!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0